/**
 * Confetti Utility
 * 
 * Fires a celebration confetti animation when a candidate joins the team.
 */

import confetti from 'canvas-confetti';

/**
 * Trigger confetti celebration animation
 * Used when a candidate is moved to "On Team!" stage
 */
export function triggerConfetti() {
  const duration = 3000;
  const end = Date.now() + duration;
  const colors = ['#6366f1', '#8b5cf6', '#a855f7', '#22c55e', '#eab308', '#f97316'];

  // Side cannons firing continuously
  (function frame() {
    confetti({
      particleCount: 3,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors: colors
    });
    confetti({
      particleCount: 3,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors: colors
    });

    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  }());
  
  // Big burst in the center after a short delay
  setTimeout(() => {
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
      colors: colors
    });
  }, 500);
}
